import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUserInfo } from '@/store/slices/userInfo.js';
import logo from '@/assets/LOGO.svg';
import './index.less';
import { authService } from '@/api/index';
import message from '@/utils/message';

export default function Signup({ setCurrentPage }) {
  const queryString = window.location.search;
  const googleLoginUri = `${location.origin}/api/oauth/google`;
  const obj = {};
  obj.utm_source = sessionStorage.getItem('source');
  obj.utm_campaign = sessionStorage.getItem('campaign');
  obj.utm_term = sessionStorage.getItem('term');
  obj.utm_ad = sessionStorage.getItem('ad');
  obj.recall = sessionStorage.getItem('recall');
  if (sessionStorage.getItem('feature')) {
    obj.path = 'tool';
  }
  const searchParams = new URLSearchParams(queryString);
  for (const [key, value] of searchParams) {
    obj[key] = value;
  }
  const state = btoa(encodeURIComponent(JSON.stringify(obj)));
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [emailCheck, setEmailCheck] = useState(false);
  const [warningText, setWarningText] = useState('');

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  // const stateUserInfo = useSelector((state) => state.userInfo);
  const handleCheckEmail = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email) && email) {
      setEmailCheck(true);
      setWarningText('Please enter the correct email address');
      return false;
    }
    if (emailCheck && email) {
      setEmailCheck(false);
      setWarningText('');
    }
    return true;
  };
  // 用户输入邮箱
  const handleInputEmail = (val) => {
    setEmail(val.target.value);
    setEmailCheck(false);
    setWarningText('');
    dispatch(setUserInfo({ key: 'email', value: val.target.value }));
  };
  // 验证邮箱是否存在
  const handleAuthExist = async () => {
    window.onClickGATrackEvent('signup-continue');
    if (!handleCheckEmail()) return;
    if (!email) {
      setWarningText('Please enter your email address');
      setEmailCheck(true);
      return;
    }
    if (email.length > 200) {
      setWarningText('Please enter the correct email address');
      setEmailCheck(true);
      return;
    }
    setLoading(true);
    try {
      const res = await authService.authExist({
        email,
      });
      if (res.code === 0) {
        if (res.data.exist) {
          console.log('message提醒 用户已存在');
          message.warning('your email address is already existed');
        } else {
          console.log('用户不存在');
          getEmailCode();
        }
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  // 获取邮箱验证码
  const getEmailCode = async () => {
    try {
      const res = await authService.authEmailCode({
        email,
        usage: 0,
      });
      if (res.code === 0) {
        console.log('message提醒 验证码发送成功');
        if (setCurrentPage) {
          setCurrentPage('verify');
          return;
        }
        navigate('/verify');
      } else {
        console.log('message提醒 验证码发送失败');
      }
    } catch (error) {
      console.log(error, 'emailCodeError');
    }
    setLoading(false);
  };

  // 初始化
  useEffect(() => {
    dispatch(setUserInfo({ key: 'email', value: '' }));
    dispatch(setUserInfo({ key: 'emailCode', value: '' }));
    dispatch(setUserInfo({ key: 'formpage', value: 'signup' }));
    loadGoogleSignInScript();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 谷歌登录初始化
  const loadGoogleSignInScript = () => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    script.onload = () => {
      initializeGoogleSignIn();
    };
  };
  // 初始化 Google 登录逻辑或设置回调
  const initializeGoogleSignIn = () => {
    console.log('Google GSI script loaded.');
  };
  // 跳转注册页面
  const navigateToLogin = () => {
    if (setCurrentPage) {
      setCurrentPage('login');
      return;
    }
    navigate('/login');
  };

  // 添加回车键盘监听
  useEffect(() => {
    const handleEnterPress = (e) => {
      if (e.key === 'Enter') {
        handleAuthExist();
      }
    };

    document.addEventListener('keydown', handleEnterPress);

    return () => {
      document.removeEventListener('keydown', handleEnterPress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return (
    <div className="signupBox">
      <img src={logo} className="logo" alt="" />
      <div className="text">Sign up</div>
      <div className="warning_text">{emailCheck && warningText}</div>
      <input
        type="text"
        placeholder="Email Address"
        onInput={handleInputEmail}
        onBlur={handleCheckEmail}
        className={`input input-bordered email_ipt ${emailCheck ? 'input-error' : ''}`}
      />
      {loading ? (
        <button className="btn btn-primary continue_btn">
          <span className="loading loading-spinner loading-md"></span>
        </button>
      ) : (
        <button className="btn btn-primary continue_btn" onClick={handleAuthExist}>
          Continue
        </button>
      )}

      <div className="more_operations">
        <div className="sign_up">
          Already have an account ? <span onClick={navigateToLogin}>Log in</span>
        </div>
      </div>
      <div className="or_line">
        <span className="line"></span>
        <span className="text">OR</span>
        <span className="line"></span>
      </div>

      <div>
        <div
          id="g_id_onload"
          data-auto_prompt="true"
          data-auto_select="false"
          data-client_id="375782144745-60viikk2fg5g49n6i85qcd2lsk0fpkol.apps.googleusercontent.com"
          data-context="use"
          data-ux_mode="redirect"
          data-skip_prompt_cookie="talecast_token"
          data-login_uri={googleLoginUri}
          data-state={state}
          data-cancel_on_tap_outside="true"
          // style={{ width: '440px' }}
          data-itp_support="true"></div>
        <div
          className="g_id_signin custom-google-signin"
          data-type="standard"
          data-shape="rectangular"
          data-theme="outline"
          data-text="signin_with"
          data-size="large"
          data-logo_alignment="left"
          data-width="440"
          data-border="none"
          data-click_listener="onClickHandler"></div>
      </div>
    </div>
  );
}
